import { render, staticRenderFns } from "./DeletePartnerModal.vue?vue&type=template&id=a231d6c4&scoped=true&class=fill-height&"
import script from "./DeletePartnerModal.vue?vue&type=script&lang=ts&"
export * from "./DeletePartnerModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePartnerModal.vue?vue&type=style&index=0&id=a231d6c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a231d6c4",
  null
  
)

export default component.exports